export default __webpack_public_path__ + "static/media/search_icon.1aad807f.svg";